import React from 'react';
import { Users, TrendingUp, Trophy, BellRing } from 'lucide-react';
import { Lead, STAGES } from '../types';
import { KpiGrid } from './KpiGrid';
import { LeadCard } from './LeadCard';
import { eur, todayStr } from '../lib/utils';
interface PipelineViewProps {
  leads: Lead[];
  onLeadClick: (id: string) => void;
}
const STAGE_ACCENT: Record<string, {
  dot: string;
  border: string;
  bg: string;
}> = {
  new: {
    dot: 'bg-blue',
    border: 'border-t-blue',
    bg: 'bg-blue/5'
  },
  qual: {
    dot: 'bg-amber',
    border: 'border-t-amber',
    bg: 'bg-amber/5'
  },
  cita: {
    dot: 'bg-wood',
    border: 'border-t-wood',
    bg: 'bg-wood/5'
  },
  pres: {
    dot: 'bg-purple',
    border: 'border-t-purple',
    bg: 'bg-purple/5'
  },
  win: {
    dot: 'bg-green',
    border: 'border-t-green',
    bg: 'bg-green/5'
  }
};
export function PipelineView({
  leads,
  onLeadClick
}: PipelineViewProps) {
  const openLeads = leads.filter(l => l.stage !== 'win');
  const pipeValue = openLeads.reduce((sum, l) => sum + (l.value || 0), 0);
  const wonLeads = leads.filter(l => l.stage === 'win');
  const wonValue = wonLeads.reduce((sum, l) => sum + (l.value || 0), 0);
  const dueToday = leads.filter(l => l.next && l.next <= todayStr() && l.stage !== 'win').length;
  const kpis = [{
    label: 'Leads activos',
    value: openLeads.length,
    subtitle: 'en proceso',
    icon: Users
  }, {
    label: 'Pipeline',
    value: eur(pipeValue),
    subtitle: 'por cerrar',
    accent: 'wood' as const,
    icon: TrendingUp
  }, {
    label: 'Ganado',
    value: eur(wonValue),
    subtitle: `${wonLeads.length} obras`,
    accent: 'green' as const,
    icon: Trophy
  }, {
    label: 'Seguir hoy',
    value: dueToday,
    subtitle: 'pendientes',
    accent: dueToday > 0 ? 'red' as const : undefined,
    icon: BellRing
  }];
  return <div data-id="element-167">
      <KpiGrid kpis={kpis} data-id="element-168" />
      <div className="grid md:grid-cols-5 gap-3" data-id="element-169">
        {STAGES.map(stage => {
        const stageLeads = leads.filter(l => l.stage === stage.id);
        const accent = STAGE_ACCENT[stage.id];
        return <div key={stage.id} className={`bg-white/70 border border-line border-t-2 ${accent.border} rounded-2xl p-3 min-h-[120px] backdrop-blur-sm`} data-id="element-170">
              <div className="flex items-center justify-between mb-3 px-0.5" data-id="element-171">
                <div className="font-poppins font-extrabold text-[13px] flex items-center gap-2 text-charcoal uppercase tracking-wide" data-id="element-172">
                  <span className={`w-2 h-2 rounded-full ${accent.dot} ring-2 ring-offset-1 ring-offset-white/0 ring-current/20`} data-id="element-173"></span>
                  {stage.name}
                </div>
                <div className="bg-charcoal text-white text-[11px] font-extrabold rounded-full px-2.5 py-0.5 min-w-[24px] text-center" data-id="element-174">
                  {stageLeads.length}
                </div>
              </div>
              {stageLeads.length === 0 ? <div className={`text-center text-[#b3a89a] text-[12px] py-5 px-2 font-semibold rounded-lg border border-dashed border-line ${accent.bg}`} data-id="element-175">
                  Vacío
                </div> : stageLeads.map(lead => <LeadCard key={lead.id} lead={lead} onClick={() => onLeadClick(lead.id)} data-id="element-176" />)}
            </div>;
      })}
      </div>
    </div>;
}